module.exports = __webpack_public_path__ + "img/qr-code-travel-data.2f875e91.png";